import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as BsIcons from 'react-icons/bs';
import SafeIcon from '../common/SafeIcon';

const { BsActivity } = BsIcons;

const Navbar = () => {
  const location = useLocation();
  
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Health Resources', path: '/resources' },
    { name: 'Top Recommendations', path: '/review/the-brain-song' },
  ];

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <SafeIcon icon={BsActivity} className="text-2xl text-indigo-600" />
            <span className="text-xl font-bold tracking-tight text-slate-900 uppercase">
              Neuro<span className="text-indigo-600">Pulse</span> <span className="text-slate-400 font-light">Insights</span>
            </span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link 
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold transition-colors ${
                  location.pathname === link.path ? 'text-indigo-600' : 'text-slate-600 hover:text-indigo-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Link 
              to="/review/the-brain-song"
              className="bg-indigo-600 text-white px-5 py-2.5 rounded-full text-sm font-bold shadow-lg shadow-indigo-100"
            >
              Latest Review
            </Link>
          </motion.div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;